export class NumberUtil {
	static numberToShortString(num: number, decimalPoints: number = 2): { number: number; denominator: string } {
		num = num ? +num : 0;

		let denominator = '';
		if (num >= 1000000000) {
			num = num / 1000000000;
			denominator = 'B';
		} else if (num >= 1000000) {
			num = num / 1000000;
			denominator = 'M';
		} else if (num >= 1000) {
			num = num / 1000;
			denominator = 'K';
		}

		// round to the specified number of decimal places
		num = parseFloat(num.toFixed(decimalPoints));

		return { number: num, denominator };
	}
}
